import { StyleSheet } from 'aphrodite';
import { brandPrimaryText } from '../../../styles/colors';
import { THEME } from '../../../components-v2/Theme/theme';

const { spacing, colors } = THEME;

export const styleSheet = StyleSheet.create({
	// Clear Search + the view toggle, kept adjacent and inline (left) with the filters.
	trailingActions: {
		display: 'flex',
		alignItems: 'center',
		gap: spacing.sm,
	},
	// Calendar view brings its own card, so strip the data-board body's box chrome to avoid a box-in-a-box.
	calendarBody: {
		border: 'none',
		borderRadius: 0,
		background: 'transparent',
		overflow: 'hidden',
	},
	container: {
		boxSizing: 'border-box',
		width: '100%',
		height: '100%',
		paddingTop: spacing.lg,
		backgroundColor: 'transparent !important',
	},
	databoardContainer: {
		boxSizing: 'border-box',
		width: '100%',
		height: '100%',
		backgroundColor: 'transparent !important',
	},
	searchInput: {
		width: 400,
		minWidth: 250,
		flexShrink: 1,
		borderRadius: 8,
		backgroundColor: colors.background.light,
	},
	titleCell: {
		maxWidth: 300,
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
	},
	titleSubtitle: {
		display: 'block',
		fontSize: 12,
		color: colors.text.light,
		marginTop: 2,
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
	},
	contactsCell: {
		display: 'flex',
		alignItems: 'center',
		gap: 4,
	},
	moreContactsButton: {
		border: 'none',
		background: 'none',
		color: brandPrimaryText,
		fontSize: 12,
		cursor: 'pointer',
		padding: 0,
		whiteSpace: 'nowrap',
		fontWeight: 500,
		':hover': {
			textDecoration: 'underline',
		},
	},
	moreContactsPopover: {
		display: 'flex',
		flexDirection: 'column',
		gap: 4,
		padding: 8,
		maxWidth: 300,
	},
});
